import React, { FC } from 'react';
import { View } from 'react-native';

import ModalHeader from '@components/modal/ModalHeader';
import AttachEntitiesList from '@components/common/AttachEntitiesList';
import RichTextEditor from '@v2/elements/RichTextEditor';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import type { RichTextEditorModalProps } from '@v2/elements/RichTextEditor/types';

const RichTextEditorModal: FC<RichTextEditorModalProps> = ({
  isVisible,
  rteKey,
  onCancel,
  onDone,
  richNoteContent,
  setRichNoteContent,
  setTouched,
  noteLinks,
  imageDocumentReferences,
  onAttachItemPress,
  handleGenerateImageURL,
  scale = initialScale,
  font = initialFont,
  C,
}) => {
  return (
    <View
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: C('Background/Light/Modal Highlight'),
        borderRadius: scale(SCREEN_BORDER_RADIUS),
        overflow: 'hidden',
        zIndex: 10,
        display: isVisible ? 'flex' : 'none',
      }}
      pointerEvents={isVisible ? 'auto' : 'none'}
    >
      <ModalHeader onCancel={onCancel} onSubmit={onDone} title="Add Note" scale={scale} font={font} C={C} />

      <AttachEntitiesList
        imageDocumentLinks={noteLinks}
        imageDocumentReferences={imageDocumentReferences}
        onAttachItemPress={onAttachItemPress}
        scale={scale}
        font={font}
        C={C}
        style={{ marginHorizontal: scale(16), marginBottom: scale(8) }}
      />

      <View style={{ flex: 1, marginHorizontal: scale(16), marginBottom: scale(16), borderRadius: scale(SCREEN_BORDER_RADIUS), overflow: 'hidden' }}>
        <RichTextEditor
          key={rteKey}
          onChange={setRichNoteContent}
          setTouched={setTouched}
          generateImageURL={handleGenerateImageURL}
          activeNote={null}
          rawContent={richNoteContent || undefined}
          scale={scale}
          font={font}
          editorBackgroundColor={C('Overlay/Light/Dim light')}
          editorBorderColor={C('Hairline/Light/No trans [mobile]')}
        />
      </View>
    </View>
  );
};

export default RichTextEditorModal;
